import { render, staticRenderFns } from "./PermissionDetails.vue?vue&type=template&id=2c5aad5c&scoped=true"
import script from "./PermissionDetails.vue?vue&type=script&lang=js"
export * from "./PermissionDetails.vue?vue&type=script&lang=js"
import style0 from "./PermissionDetails.vue?vue&type=style&index=0&id=2c5aad5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5aad5c",
  null
  
)

export default component.exports